
//---------- PLACE OF DELIVERY ----------------\\

import { Order } from "@shared-logic/orders";
import { PlaceOfDelivery } from "./locations.interface";
import { PLACE_OF_DELIVERY_CONST } from "./place-of-delivery/place-of-delivery";
import { PLANTAS_INTERIOR_MAP } from "./place-of-delivery/plantas-interior";
import { puertos } from "./place-of-delivery/puertos";
import { isBuyerWithNoSpecificPort } from "@shared-logic/subjects/buyers-validations";

export function getPlaceOfDeliveryIBM(order: Order) {
    let placeOfDelivery: PlaceOfDelivery = order.price.placeOfDelivery;
    let noPortRequired: boolean = isBuyerWithNoSpecificPort(order.price.observations.buyer);
    let valueToReturn: number = 0;

    switch (placeOfDelivery.zone) {
        case PLACE_OF_DELIVERY_CONST.ROSARIO_NORTE: valueToReturn = getZoneOfRosarioNorte(placeOfDelivery.port, noPortRequired); break;
        case PLACE_OF_DELIVERY_CONST.ROSARIO_SUR: valueToReturn = getZoneOfRosarioSur(placeOfDelivery.port, noPortRequired); break;
        case PLACE_OF_DELIVERY_CONST.ROSARIO: valueToReturn = 5; break;
        case PLACE_OF_DELIVERY_CONST.UP_RIVER: valueToReturn = 90001; break;
        case PLACE_OF_DELIVERY_CONST.ROSARIO_NORTE_Y_ROSARIO: valueToReturn = (noPortRequired ? 1503 : 0); break; //ROS NOR Y ROS
        case PLACE_OF_DELIVERY_CONST.ROSARIO_SUR_Y_ROSARIO: valueToReturn = (noPortRequired ? 1504 : 0); break; //ROS SUR Y ROS
        case PLACE_OF_DELIVERY_CONST.ROSARIO_NORTE_Y_SUR: valueToReturn = (noPortRequired ? 1502 : 0); break; //ROS NOR Y ROS SUR
        case PLACE_OF_DELIVERY_CONST.PUERTOS_BUENOS_AIRES: valueToReturn = getZoneOfPuertosBuenosAires(placeOfDelivery.port); break;
        case PLACE_OF_DELIVERY_CONST.PUERTOS_ENTRE_RIOS: valueToReturn = getZoneOfPuertosEntreRios(placeOfDelivery.port); break;
        case PLACE_OF_DELIVERY_CONST.PLANTAS_GRASSI: valueToReturn = getZoneOfPlantasGrassi(placeOfDelivery.port); break;
        case PLACE_OF_DELIVERY_CONST.PLANTAS_INTERIOR: valueToReturn = getZoneOfPlantasInterior(placeOfDelivery.port); break;
    }

    return valueToReturn;
}

export function getZoneOfRosarioNorte(port: number, noPortRequired: boolean) {
    let valueToReturn = 0;
    if (noPortRequired) return 1500;

    switch (port) {
        case 1: valueToReturn = 6; break;
        case 2: valueToReturn = 12; break;
        case 3: valueToReturn = 322; break;
        case 4: valueToReturn = 180; break;
        default: valueToReturn = 0; break;
    }
    return valueToReturn;
}

export function getZoneOfRosarioSur(port: number, noPortRequired: boolean) {
    let valueToReturn = 0;
    if (noPortRequired) return 1501;

    switch (port) {
        case 1: valueToReturn = 359; break;
        case 2: valueToReturn = 350; break;
        case 3: valueToReturn = 215; break;
        case 4: valueToReturn = 8; break;
        default: valueToReturn = 0; break;
    }
    return valueToReturn;
}

export function getZoneOfPuertosBuenosAires(port: number) {
    let valueToReturn = 0;
    switch (port) {
        case 1: valueToReturn = 1; break;
        case 2: valueToReturn = 132; break;
        case 3: valueToReturn = 426; break;
        case 4: valueToReturn = 551; break;
        case 5: valueToReturn = 11; break;
        case 6: valueToReturn = 41; break;
        default: valueToReturn = 2; break;
    }
    return valueToReturn;
}

export function getZoneOfPuertosEntreRios(zone: number) {
    let valueToReturn = 0;
    switch (zone) {
        case 1: valueToReturn = 945; break;
        case 2: valueToReturn = 4; break;
    }
    return valueToReturn;
}

export function getZoneOfPlantasGrassi(zone: number) {
    let valueToReturn = 0;
    switch (zone) {
        case 1: valueToReturn = 366; break;
        case 2: valueToReturn = 858; break;
        case 3: valueToReturn = 310; break;
    }
    return valueToReturn;
}

export function getZoneOfPlantasInterior(zone: number) {
    return getStructPlantasInterior(zone).cgo;
}

export function getStructPlantasInterior(port: number) {
    const plantas_interior = Object.entries(PLANTAS_INTERIOR_MAP);
    const quantItems = plantas_interior.length;
    const portString = puertos[11].dropdown[port - 1].toLowerCase();
    let valueToReturn: any;

    try {
        for (let i = 0; i < quantItems; i++) {
            if (plantas_interior[i][1].nombre.toLowerCase() == portString) {
                valueToReturn = plantas_interior[i][1];
                throw new Error();
            }
        }
        return null;
    } catch (err) { }

    return valueToReturn;
}